module.exports = __webpack_public_path__ + "img/16131231005.Smebank.53b36c89.svg";